// 3rd party imports
import * as React from 'react';
import { inject } from 'mobx-react';

// bernie
import { AnalyticsStore } from 'bernie-plugin-mobx';
import { DialogRoute, closeDialog } from 'bernie-core';
import { Layer } from 'bernie-view';

// mobx
import { UserAuthStore, PzStore } from 'stores';

// util
import { getUserAnalyticsMicroMessage } from '../../util/analytics';

// shared-ui
import { ILocalization, LocalizedText } from '@shared-ui/localization-context';

// ui
import { UitkDialog, UitkDialogContent, UitkDialogFooter } from 'uitk-react-dialog';
import { UitkSpacing } from 'uitk-react-spacing';
import { UitkText } from 'uitk-react-text';

import { useHistory, useLocation } from 'react-router-dom';

export interface ExceptionIndustryDialogProps {
  analytics?: AnalyticsStore;
  userAuth?: UserAuthStore;
  l10n?: ILocalization;
  industry: string;
  pzStore?: PzStore;
}

export const ExceptionIndustryDialog: React.FunctionComponent<ExceptionIndustryDialogProps> = inject(
  'analytics',
  'userAuth',
  'pzStore',
)(({ analytics, userAuth, l10n, industry, pzStore }) => {
  const dialogId = 'exception-industry';

  const history = useHistory();
  const location = useLocation();

  let exceptionIndustryCopy;
  let exceptionIndustryCta;
  let rfrrIdSelected;
  let linkNameSelected;
  let clickCallback;

  switch (industry) {
    case 'travel_agents':
      exceptionIndustryCopy = l10n.formatText('signup.taap_dialog.text.specialized_affiliate_program');
      exceptionIndustryCta = l10n.formatText('signup.taap_dialog.button.proceed');
      rfrrIdSelected = 'affhub_signup_taap.selected';
      linkNameSelected = 'AffHub Sign Up TAAP Selected';
      clickCallback = () => window.location.assign('https://www.expedia.com/taap-info');
      break;
    case 'sub-affiliate_networks':
      exceptionIndustryCopy = l10n.formatText('signup.sub_affiliate_network_dialog.text.not_accepting');
      exceptionIndustryCta = l10n.formatText('common.dialog.close');
      rfrrIdSelected = 'affhub_signup_sub-affiliate-network.selected';
      linkNameSelected = 'AffHub Sign Up Sub Affiliate Network Selected';
      clickCallback = () => closeDialog({ history, location, key: dialogId });
      break;
  }

  const onDismiss = () => {
    closeDialog({ history, location, key: dialogId });
  };

  const onClickProceed = () => {
    analytics.trackEvent(rfrrIdSelected, linkNameSelected, null, null, true, [
      getUserAnalyticsMicroMessage(userAuth?.currentUserDetails, pzStore?.pzPublisher),
    ]);

    clickCallback();
  };

  return (
    <>
      <DialogRoute id={dialogId}>
        <Layer id="dialogRedirect" onDismiss={onDismiss}>
          <UitkDialog returnFocusOnClose={true}>
            <UitkDialogContent>
              <UitkSpacing margin={{ block: 'two' }}>
                <UitkText>{exceptionIndustryCopy}</UitkText>
              </UitkSpacing>
            </UitkDialogContent>
            <UitkDialogFooter
              key="UitkDialogFooter"
              buttonOne={{
                onClick: onClickProceed,
                text: exceptionIndustryCta,
                type: 'tertiary',
              }}
            />
          </UitkDialog>
        </Layer>
      </DialogRoute>
    </>
  );
});
